// /* eslint-disable react-hooks/exhaustive-deps */
// import { useContext, useEffect, useState } from 'react';
// import Axios from 'axios'
// import { Form } from 'react-bootstrap';
// import AsyncSelect from 'react-select/async';

// import DashboardContext from '../../Context';
// import PropTypes from 'prop-types';

// /**
//  * این کامپوننت برای دارپ دان های که هم چند تا متغغیر میگیر هم برای هر متغییر یک درخواست به سرور می زند
//  */
// export default function InputControlAsyncMulti({ url, name, defaultValue, handelValue, label, idSelect }) {

//     const { authentication, urldashboard, handelerrors } = useContext(DashboardContext);

//     const [datadefult, setDatadefult] = useState({})

//     const dataFeching = async (value) => {

//         try {
//             const res = await Axios.get(`${urldashboard}${url}/${value}`, {
//                 headers: {
//                     "Authorization": authentication,
//                     "Content-Type": "application/json; charset=utf-8 "
//                 }
//             })
//             const data = await res.data.data

//             debugger

//             if (defaultValue) {
//                 debugger
//                 setDatadefult(data.filter(item => item.value.toString() === idSelect.toString())[0])

//             }
//             return data

//         } catch (error) {
//             handelerrors(error)

//         }
//     }

//     const handeloncheng = (event) => {
//         let datavalue = []

//         if (event) {
//             event.map(item => datavalue.push(item.value))
//         }
//         else {
//             datavalue = []
//         }
//         //console.log(datavalue);
//         handelValue(name, datavalue)

//     }

//     const handelloadOptions = value => {

//         if (value.length > 3) {
//             return dataFeching(value)
//         }
//     }

//     useEffect(() => {

//         if (defaultValue) {
//             debugger
//             dataFeching(defaultValue)
//         }
//         return () => {

//         }
//     }, [defaultValue])


//     return (
//         <Form.Group>
//             {
//                 label ? <Form.Label>{label}</Form.Label>
//                     : null
//             }
//             {
//                 defaultValue !== undefined ?
//                     datadefult.hasOwnProperty('label') ?
//                         <AsyncSelect
//                             className="basic-single"
//                             classNamePrefix="select"
//                             styles={{ menu: provided => ({ ...provided, zIndex: 9999 }) }}
//                             onChange={handeloncheng}
//                             defaultValue={datadefult}
//                             isRtl
//                             isMulti
//                             name={name}
//                             loadOptions={handelloadOptions}
//                             cacheOptions
//                             defaultOptions

//                         />
//                         : null
//                     :
//                     <AsyncSelect
//                         className="basic-single"
//                         classNamePrefix="select"
//                         styles={{ menu: provided => ({ ...provided, zIndex: 9999 }) }}
//                         onChange={handeloncheng}
//                         isRtl
//                         isMulti
//                         isClearable
//                         name={name}
//                         loadOptions={handelloadOptions}
//                         cacheOptions
//                         defaultOptions

//                     />
//             }
//         </Form.Group>
//     )
// }
// InputControlAsyncMulti.propTypes = {
//     /**لیبل اینپوت است */
//     label: PropTypes.string,
//     /**برای ارسال مقدار اولیه برای اینپوت است */
//     defaultValue: PropTypes.string,
//     /** نام اینپوت است */
//     name: PropTypes.string,
//     /** ارسال مقدار اینپوت به بالا است */
//     handelValue: PropTypes.func,
//     /**آدرس که برای دریافت داده استفاده می شود */
//     url: PropTypes.string,
//     /**ایدی چیزی است که باید انتخاب شود */
//     idSelect: PropTypes.string,
// };





/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react';
import Axios from 'axios'
import { Form } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';

import DashboardContext from '../../Context';
import PropTypes from 'prop-types';

/**
 * این کامپوننت برای دارپ دان های که هم چند تا متغغیر میگیر هم برای هر متغییر یک درخواست به سرور می زند
 */
export default function InputControlAsyncMulti({ url, name, defaultValue, handelValue, label, idSelect, isDefaultValue, disabled }) {

    const { authentication, urldashboard, handelerrors } = useContext(DashboardContext);

    const [datadefult, setDatadefult] = useState([])

    const dataFeching = async (value) => {

        // var str = '';

        // if (Array.isArray(value)) {
        //     var labels = value.map(x => x.label);
        //     labels.forEach(label => {
        //         str += label + ','
        //     });

        // } else {
        //     str += value;
        // }

        try {
            const res = await Axios.get(`${urldashboard}${url}/${value}`, {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json; charset=utf-8 "
                }
            })
            const data = await res.data.data

            if (!isDefaultValue) {
                if (defaultValue)
                    setDatadefult(defaultValue);
            } else {
                if (defaultValue.length > 0) {
                    //setDatadefult(data.filter(item => item.value.toString() === idSelect.toString())[0])
                    setDatadefult(defaultValue);
                }
            }

            return data

        } catch (error) {
            handelerrors(error)
        }
    }

    const handeloncheng = (event) => {

        if (event !== null) {
            setDatadefult(event);
        } else {
            setDatadefult([]);
        }

        let datavalue = []

        if (event) {
            event.map(item => datavalue.push(item.value))
        }
        else {
            datavalue = []
        }
        ////console.log(datavalue);
        handelValue(name, datavalue)
    }

    const handelloadOptions = value => {

        if (value.length > 3) {
            return dataFeching(value)
        }
    }

    useEffect(() => {
        if (defaultValue?.length > 0) {
            dataFeching(defaultValue)
        } else {
            setDatadefult([])
        }
        return () => { }
    }, [defaultValue])

    return (
        <Form.Group>
            {
                label ? <Form.Label>{label}</Form.Label>
                    : null
            }
            {
                (defaultValue !== undefined && defaultValue.length > 0) ?
                    datadefult[0]?.hasOwnProperty('label') ?
                        <AsyncSelect
                            className="basic-single"
                            classNamePrefix="select"
                            styles={{ menu: provided => ({ ...provided, zIndex: 9999 }) }}
                            onChange={handeloncheng}
                            defaultValue={datadefult}
                            isRtl
                            isMulti
                            name={name}
                            loadOptions={handelloadOptions}
                            cacheOptions
                            defaultOptions
                            isDisabled={disabled}
                        />
                        : null
                    :
                    <AsyncSelect
                        className="basic-single"
                        classNamePrefix="select"
                        styles={{ menu: provided => ({ ...provided, zIndex: 9999 }) }}
                        onChange={handeloncheng}
                        isRtl
                        isMulti
                        isClearable
                        value={datadefult}
                        name={name}
                        loadOptions={handelloadOptions}
                        cacheOptions
                        defaultOptions
                        isDisabled={disabled}
                    />
            }
        </Form.Group>
    )
}
InputControlAsyncMulti.propTypes = {
    /**لیبل اینپوت است */
    label: PropTypes.string,
    /**برای ارسال مقدار اولیه برای اینپوت است */
    defaultValue: PropTypes.string,
    /** نام اینپوت است */
    name: PropTypes.string,
    /** ارسال مقدار اینپوت به بالا است */
    handelValue: PropTypes.func,
    /**آدرس که برای دریافت داده استفاده می شود */
    url: PropTypes.string,
    /**ایدی چیزی است که باید انتخاب شود */
    idSelect: PropTypes.string,
};

